import { render, staticRenderFns } from "./myPopover.vue?vue&type=template&id=b88d3280&scoped=true&"
import script from "./myPopover.vue?vue&type=script&lang=js&"
export * from "./myPopover.vue?vue&type=script&lang=js&"
import style0 from "./myPopover.vue?vue&type=style&index=0&id=b88d3280&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88d3280",
  null
  
)

export default component.exports